import { render, staticRenderFns } from "./UploadMenuItem.vue?vue&type=template&id=0753ee4a"
import script from "./UploadMenuItem.vue?vue&type=script&lang=ts"
export * from "./UploadMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports